// TODO(GROW-202): replace with the real opt-in call once Reporting builds it.
// This resolves without doing anything — success is signalled by resolving —
// so swapping in the real call is a change to this body alone.
export async function optIntoSignals() {}
